import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "samplecomponent" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, "Icon", -1)
const _hoisted_3 = { class: "samplecomponent__article" }
const _hoisted_4 = { class: "samplecomponent__reactive" }
const _hoisted_5 = { class: "samplecomponent__component" }
const _hoisted_6 = { class: "samplecomponent__resizable" }
const _hoisted_7 = { class: "samplecomponent__options" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "text--xs" }, "Props", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("OR")
const _hoisted_10 = { class: "samplecomponent__article" }
const _hoisted_11 = /*#__PURE__*/_createVNode("h2", null, "Icon list", -1)
const _hoisted_12 = { class: "sample__icons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_InputSelect = _resolveComponent("InputSelect")
  const _component_InputText = _resolveComponent("InputText")
  const _component_InputCheckbox = _resolveComponent("InputCheckbox")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_Icon, {
              name: _ctx.props.name,
              title: _ctx.props.title,
              size: _ctx.props.size,
              color: _ctx.props.isCustomColor ? _ctx.props.color : undefined,
              customSize: _ctx.props.isCustomSize ? _ctx.props.customSize : undefined,
              width: _ctx.props.isCustomSize && _ctx.props.width && _ctx.props.height ? _ctx.props.width : undefined,
              height: _ctx.props.isCustomSize && _ctx.props.width && _ctx.props.height ? _ctx.props.height : undefined
            }, null, 8, ["name", "title", "size", "color", "customSize", "width", "height"])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode("p", null, [
            _createVNode(_component_InputSelect, {
              modelValue: _ctx.props.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.props.name = $event)),
              options: _ctx.icons,
              label: "name"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputText, {
              modelValue: _ctx.props.title,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.props.title = $event)),
              label: "title"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputCheckbox, {
              modelValue: _ctx.props.isCustomColor,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.props.isCustomColor = $event)),
              label: "color"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_InputText, {
              modelValue: _ctx.props.color,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.props.color = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputSelect, {
              modelValue: _ctx.props.size,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.props.size = $event)),
              options: _ctx.sizesX,
              label: "size"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createVNode("p", null, [
            _createVNode(_component_InputCheckbox, {
              modelValue: _ctx.props.isCustomSize,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.props.isCustomSize = $event)),
              label: "customSize"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_InputText, {
              modelValue: _ctx.props.customSize,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.props.customSize = $event))
            }, null, 8, ["modelValue"]),
            _createVNode("p", null, [
              _hoisted_9,
              _createVNode(_component_InputText, {
                modelValue: _ctx.props.width,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.props.width = $event)),
                label: "width"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_InputText, {
                modelValue: _ctx.props.height,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.props.height = $event)),
                label: "height"
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_10, [
      _hoisted_11,
      _createVNode("div", _hoisted_12, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.icons, (icon) => {
          return (_openBlock(), _createBlock("div", {
            class: "icon__wrapper",
            key: icon
          }, [
            _createVNode(_component_Icon, {
              name: icon,
              title: icon,
              size: "lg"
            }, null, 8, ["name", "title"]),
            _createVNode("span", null, _toDisplayString(icon), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}